// extracted by mini-css-extract-plugin
module.exports = {"container":"NoResults_container__FecPz","title":"NoResults_title__2EPR_","description":"NoResults_description__n4F0f"};